import { trackClick as trackLinkClick } from "tracking"

export const trackClick = (categoryName: string, id: string): void => {
  trackLinkClick({
    event: "Page Element Clicked",
    properties: {
      module_content: id,
      module_content_details: categoryName || "",
      location_type: "page",
    },
  })
}
